import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  CampaignWrapper,
  ImageWrapper,
  TileImage,
  CampaignLabel,
  CampaignText,
} from './StyledComponents';

export const CampaignIcon = ({
  name,
  tileImage,
  isActive,
  isSelected,
  onClick,
}) => {
  const { t } = useTranslation('activityBoard');

  return (
    <CampaignWrapper onClick={onClick} data-testid="campaign-wrapper">
      <ImageWrapper>
        <TileImage
          height="58px"
          width="58px"
          isSelected={isSelected}
          src={tileImage}
          data-testid="tile-image"
        />
        {isActive && (
          <CampaignLabel
            isSelected={isSelected}
            fontSize="10px"
            fontWeight="600"
          >
            {t('campaignIcon.live')}
          </CampaignLabel>
        )}
      </ImageWrapper>
      <CampaignText isSelected={isSelected} variant="subtitle2">
        {name}
      </CampaignText>
    </CampaignWrapper>
  );
};

CampaignIcon.propTypes = {
  name: PropTypes.string,
  tileImage: PropTypes.string,
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};
